import { useQuery } from 'react-query';

import {
  getInvoiceCardDetails,
  type GetInvoiceCardDetailsInput,
} from 'modules/cards/api/getInvoiceCardDetails';

export const useGetInvoiceCardDetails = ({
  payableId,
  companyId,
  isEnabled,
}: GetInvoiceCardDetailsInput & {
  isEnabled: boolean;
}) => {
  return useQuery(
    ['cardProductRegulatoryLimits', payableId],
    () =>
      getInvoiceCardDetails({
        payableId,
        companyId,
      }),
    {
      enabled: isEnabled,
    },
  );
};
